<template>
  <div>
    <div class="order-cont">
      <div><span>退款金额</span>￥ {{ this.abs(refundInfo.refundModel.AMOUNT)}}</div>
      <div><span>退款类型</span>{{ refundInfo.refundModel.REFUND_TYPE}}</div>
      <div><span>退款原因</span>{{ refundInfo.refundModel.REFUND_REASON}}</div>
      <div v-if="refundInfo.refundModel.REFUND_TYPE=='项目终止退款'"><span>退款流程</span>{{ refundInfo.refundModel.REFUND_PROCESS_NAME}}</div>
      <div v-if="refundInfo.refundModel.REFUND_PROCESS == 1&&refundInfo.refundModel.REFUND_TYPE=='项目终止退款'">
        <span>已提供的检测服务为</span>{{refundInfo.refundModel.RESTING_SERVICES}}
      </div>
      <div><span>退款方式</span>{{ refundInfo.refundModel.PAY_TYPE}}</div>
      <template v-if="refundInfo.refundModel.PAY_TYPE.includes('银行转账')">
        <div><span>收款人姓名</span>{{ refundInfo.refundModel.PAY_ACCOUNT}}</div>
        <div><span>收款银行账号</span>{{ refundInfo.refundModel.BANK_NO }}</div>
        <div><span>开户银行全称</span>{{ refundInfo.refundModel.PAY_BANK}}</div>
          <div :class="refundInfo.deathFilePath&&refundInfo.deathFilePath.length>0?'upload-style':'upload-none'">
            <span>死亡证明</span>
            <van-uploader v-model="refundInfo.deathFilePath" multiple readonly :deletable="false"/>
          </div>
          <div :class="refundInfo.relationshipFilePath&&refundInfo.relationshipFilePath.length>0?'upload-style':'upload-none'">
            <span>关系证明</span>
            <van-uploader v-model="refundInfo.relationshipFilePath" multiple readonly :deletable="false"/>
          </div>
           <div :class="refundInfo.refundContractPath&&refundInfo.refundContractPath.length>0?'upload-style':'upload-none'">
            <span>纸质合同</span>
            <van-uploader v-model="refundInfo.refundContractPath" multiple readonly :deletable="false"/>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "refund-info",
  props:['refundInfo'],
  data() {
    return {};
  },
  mounted() {},
  methods: {
      // 金额 格式化
      abs(value) {  
        if (!value && value !== 0) return '-';
        var intPart = Number(value) | 0; //获取整数部分
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{})+$)/g, '$1,'); //将整数部分逢三一断
    
        var floatPart = ".00"; //预定义小数部分
        var value2Array = value.toString().split(".");
    
        //=2表示数据有小数位
        if (value2Array.length == 2) {
            floatPart = value2Array[1].toString(); //拿到小数部分
    
            if (floatPart.length == 1) { //补0,实际上用不着
                return intPartFormat + "." + floatPart + '0';
            } else {
                return intPartFormat + "." + floatPart;
            }
        } else {
            return intPartFormat + floatPart;
        }
    },
  },
};
</script>

<style scoped lang="less">
.order-cont {
  padding: 0 24px 17px;
  margin-top: 10px;
  & > div {
    line-height: 32px;
    font-size: 13px;
    font-weight: 400;
    color: #2f354d;
    height: 32px;
    text-align: right;
    span {
      color: #9095a7;
      float: left;
    }
  }
  .upload-style {
    height: 100%;
    span{
      display: block;
      width: 100%;
      text-align: left;
    }
    .van-uploader{
      width: 100%;
      /deep/.van-uploader__preview {
        .van-uploader__preview-image{
          background: #fff ;
          border-radius: 4px;
        }
      }
      /deep/.van-uploader__upload {
        display: none;
      }
    }
    
    .van-image {
      width: 90px;
      height: 90px;
      display: block;
    }
  }
  .upload-none{
      display: none;
    }
}
</style>
